'use client'

import { cn } from '@utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Suspense } from 'react'
import { HGLinkProps } from './links.types'

function HGLinkContent({
  href,
  children,
  className = '',
  active = false,
  activeClassName = '',
  native = false,
  scroll = true,
  replace = false,
  ...props
}: HGLinkProps) {
  const pathname = usePathname()
  const isActive = active || (href && pathname === href)
  const Tag = native ? 'a' : Link

  return (
    <Tag
      href={href}
      className={cn(className, isActive ? activeClassName : '')}
      {...(native ? {} : { scroll, replace })}
      {...props}
    >
      {children}
    </Tag>
  )
}

export default function HGLink(props: HGLinkProps) {
  return (
    <Suspense>
      <HGLinkContent {...props} />
    </Suspense>
  )
}
